import { Box, Input, List, Text } from '@chakra-ui/react';
import { Client } from '@opanuj/shared/types';
import { useState } from 'react';

interface ClientPickerProps {
    clients: Client[];
    onSelect: (client: Client | undefined) => void;
    selectedClient?: Client;
}

export const ClientPicker = ({ clients, onSelect, selectedClient }: ClientPickerProps) => {
    const [search, setSearch] = useState("");

    const filteredClients = clients.filter((client) => {
        return search.length > 0 && client?.name?.toLowerCase().includes(search.toLowerCase());
    }
    );

    return (
        <Box position="relative" width="100%">
            <Input
                value={selectedClient?.name || search}
                onChange={(e) => {
                    setSearch(e.target.value);
                    onSelect(undefined);
                }}
                placeholder="wybierz klienta..."
                onFocus={() => setSearch(selectedClient?.name || '')}
            />
            {filteredClients.length > 0 && (
                <Box
                    position="absolute"
                    top="100%"
                    left={0}
                    right={0}
                    bg="white"
                    borderRadius="md"
                    boxShadow="lg"
                    zIndex={1}
                    maxH="200px"
                    overflowY="auto"
                >
                    <List.Root gap={2} p={2}>
                        {filteredClients.map((client) => (
                            <List.Item
                                key={client.id}
                                onClick={() => {
                                    onSelect(client);
                                    setSearch("");
                                }}
                                cursor="pointer"
                                p={2}
                                _hover={{ bg: "gray.100" }}
                            >
                                <Text>{client.name}</Text>
                            </List.Item>
                        ))}
                    </List.Root>
                </Box>
            )}
        </Box>
    );
};